<template>
<div>
    <b-modal
      size="xl"
      id="order-expense-modal"
      ref="order-expense-modal"
      title="Expenses"
      centered
			:ok-disabled="okButtonDisabled"
			@ok="submitCharge"
			@hidden="expensesModalReset"
      no-close-on-backdrop
    >
      <b-row>
        <b-col sm="2"></b-col>
        <b-col sm="6">
          <b-form-group label-cols="2">
            <b-form-radio v-model="expensesObj.isInHouseExpense" name="isInHouse" :value="false" inline>Vendor Charge</b-form-radio>
            <b-form-radio v-model="expensesObj.isInHouseExpense" name="isInHouse" :value="true" inline>In-House Expense</b-form-radio>
          </b-form-group>
          <b-form-group label-cols="2" label-align="right" label="Type">
            <b-form-select @change="checkOkSubmit" v-model="expensesObj.expenseAccountId">
                <option
                  v-for="expenseType in sortSelect(expenseTypes,'accountName')"
                  :key="expenseType.id"
                  :value="expenseType.id"
                >{{expenseType.accountName}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="2" label-align="right" label="Description">
            <b-form-input v-model="expensesObj.description" @input="checkOkSubmit" />
          </b-form-group>
          <b-form-group label-cols="2" label-align="right" label="Amount">
            <b-form-input type="number" v-model="expensesObj.amount" @input="checkOkSubmit" />
          </b-form-group>
          <b-form-group label-cols="2">
            <b-form-radio v-model="expensesObj.isSpecificInventory" name="isSpecificInventory" :value="false" inline>Apply to all</b-form-radio>
            <b-form-radio v-model="expensesObj.isSpecificInventory" name="isSpecificInventory" :value="true" inline>Apply to inventory line</b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="expensesObj.isSpecificInventory">
        <h5>Inventory Received</h5>
        <p>Select the inventory received that this expense should be applied against. Applying an expense will adjust the charges and cost.</p>
        <inventory-list :gridId="inventoryGridId" :parentItems="inventoryList"  
          :parentCheckedItems="expensesObj.inventoryExpenses.map(x => x.inventoryId) || []"
          @checkedItems="inventoryChecked = $event"
          hideActions hidePrint hideReports hidePostSource />
      </div>
      
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button
          v-if="isEdit"
          size="sm"
          variant="danger"
          @click="deleteCharge"
        >
          Delete
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          v-if="okButtonDisabled"
          disabled
          size="sm"
          variant="primary"
          @click="ok()"
        >
          OK
        </b-button>
				<b-button
          v-else
          size="sm"
          variant="primary"
          @click="ok()"
        >
					OK
        </b-button>
      </template>
    </b-modal>
    <div class="d-flex justify-content-end mb-3">
      <b-button @click="openExpensesModal" size="sm" variant="primary">
        <i class="fa fa-plus" aria-hidden="true"></i>
        Add New
      </b-button>
    </div>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :gridId="gridId"
      :navigationField="'accountName'"
      :itemData="expenses"
      :fields="fields"
      :onEdit="editExpensesModal"
      :onDelete="deleteChargeGrid"
     />
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import InventoryList from '@/shared/components/InventoryList';
import gridFields from './fields';
import {GRID_ID} from '@/shared/constants';

export default {
  components: {
    GridComponent,
    InventoryList
  },
  props: {
    purchaseOrderId: {
      type: [Number, String],
      default: 0
    },
    serviceOrderId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      expensesObj: {
        id: 0,
        expenseAccountId: '',
        description: '',
        amount: '',
        inventoryExpenses: [],
        isInHouseExpense: false,
        isSpecificInventory: false,
        active: true,
      },
      fields: gridFields,
      isEdit: false,
      okButtonDisabled: true,
      expenseAccts: 7,
      gridId: '',
      inventoryList: [],
      inventoryGridId: GRID_ID.PURCHASE_ORDER_INVENTORY_EXPENSES_GRID,
      inventoryChecked: [],
      componentKey: 0
    }
  },
  computed: {
    ...mapState('purchaseorders', {
      purchaseOrderCharges: 'charges'
    }),    
    ...mapState('serviceOrders', {
      serviceOrderCharges: 'charges',
    }),
    ...mapState('chargesList', ['expenseAndIncomeAccounts']),
    ...mapGetters('serviceOrderLines', ['serviceOrderLine']),
    expenseTypes() {
      return this.expenseAndIncomeAccounts.filter(x => x.accountTypeId == this.expenseAccts).sort((a, b) => (a.accountName > b.accountName) ? 1 : -1)
    },
    expenses() {
      if (this.purchaseOrderId) {
        return this.purchaseOrderCharges;
      } else if (this.serviceOrderId) {
        return this.serviceOrderCharges;
      }
    },
  },
  methods: {
    ...mapActions('purchaseorders', {
      getPurchaseOrderChargesTypes: 'getChargesTypes',
      getPurchaseOrderChargesById: 'getChargesById',
      addNewPurchaseOrderCharge: 'addNewCharge',
      deletePurchaseOrderChargeById: 'deleteChargeById',
      editPurchaseOrderChargeById: 'editChargeById',
    }),
    ...mapActions('serviceOrders', {
      getServiceOrderChargesTypes: 'getChargesTypes',
      getServiceOrderChargesById: 'getChargesById',
      addNewServiceOrderCharge: 'addNewCharge',
      deleteServiceOrderChargeById: 'deleteChargeById',
      editServiceOrderChargeById: 'editChargeById',
    }),
    ...mapActions('chargesList', ['getExpenseAndIncomeCharges']),
    ...mapActions('inventory', ['getByFilterAndReturn']),
    checkOkSubmit() {
      //If type and description is not empty
      if(this.expensesObj.expenseAccountId && this.expensesObj.amount) {
        this.okButtonDisabled = false;
      } else {
        this.okButtonDisabled = true;
      }
    },
  	openExpensesModal() {
      this.$refs['order-expense-modal'].show();
    },
    editExpensesModal(props) {
      this.isEdit = true;

      this.expensesObj = { ...props };

      this.okButtonDisabled = false;

      this.openExpensesModal();
    },
    async submitCharge() {
      if (this.expensesObj.isSpecificInventory && this.inventoryChecked.length > 0) {
        this.expensesObj.inventoryExpenses = this.inventoryChecked.map(id => ({
          purchaseOrderId: this.purchaseOrderId,
          purchaseOrderChargeId: (this.purchaseOrderId) ? this.expensesObj.id : 0,
          serviceOrderId: this.serviceOrderId,
          serviceOrderChargeId: (this.serviceOrderId) ? this.expensesObj.id : 0,
          inventoryId: id
        }));
      } else {
        this.expensesObj.inventoryExpenses = [];
      }

      if(this.isEdit) {
        await this.editCharge();
      } else {
        await this.addNewCharge();
      }

      this.$refs['order-expense-modal'].hide();
      this.chargesList();
      this.$emit('updateExpense');
    },
    async deleteChargeGrid(props) {
      this.expensesObj = { ...props };

      await this.deleteCharge();

    },
    async deleteCharge() {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete expense?'});
      if (deleteConfirmed) {
        const quoteSummary = await this.deleteChargeById();

        //this.$emit('updateTotal',quoteSummary);

        //this.$refs['open-expense-modal'].hide();

        await this.chargesList();

        this.$emit('updateExpense');
      }
      this.expensesObj = {};
    },
    async addNewCharge() {
      if(this.purchaseOrderId) {
        await this.addNewPurchaseOrderCharge(this.expensesObj);
      } else if (this.serviceOrderId) {
        await this.addNewServiceOrderCharge(this.expensesObj);
      }
    },
    async deleteChargeById() {
      if(this.purchaseOrderId) {

        let data=await this.deletePurchaseOrderChargeById(this.expensesObj)

        

      } else if (this.serviceOrderId) {
        await this.deleteServiceOrderChargeById(this.expensesObj);
      }
      this.expensesObj = {};
    },
    async editCharge() {
      if(this.purchaseOrderId) {
        return await this.editPurchaseOrderChargeById(this.expensesObj);
      } else if (this.serviceOrderId) {
        return await this.editServiceOrderChargeById(this.expensesObj);
      }
    },
    async chargesList() {
      if(this.purchaseOrderId) {
        this.gridId = GRID_ID.PURCHASE_ORDER_EXPENSES_GRID;
        await this.getPurchaseOrderChargesById(this.purchaseOrderId);
      } else if (this.serviceOrderId) {
        this.gridId = GRID_ID.SERVICE_ORDER_EXPENSES_GRID;
        await this.getServiceOrderChargesById(this.serviceOrderId);
      }
    },
    expensesModalReset() {
      this.expensesObj = {
        id: 0,
        expenseAccountId: '',
        description: '',
        amount: '',
        inventoryExpenses: [],
        isInHouseExpense: false,
        isSpecificInventory: false,
        active: true,
      };
      
      if(this.purchaseOrderId) {
        this.expensesObj = { ...this.expensesObj, purchaseOrderId: this.purchaseOrderId, };
      } else if (this.serviceOrderId) {
        this.expensesObj = { ...this.expensesObj, serviceOrderId: this.serviceOrderId, };        
      }

      this.isEdit = false;

      this.okButtonDisabled = true;
    },
  },
  watch: {
    'serviceOrderLine.purchaseOrderLineId'() {
      if (this.serviceOrderId && this.serviceOrderLine && this.serviceOrderLine.serviceOrderId == this.serviceOrderId && this.serviceOrderLine.purchaseOrderLineId) {
        this.getByFilterAndReturn(`{purchaseOrderLineId: ${this.serviceOrderLine.purchaseOrderLineId}}`).then((res) => {
          this.inventoryList = res;
        });
      }
    }
  },
  async mounted() {
    if(this.purchaseOrderId) {
      this.gridId = GRID_ID.PURCHASE_ORDER_EXPENSES_GRID;
      this.expensesObj = { ...this.expensesObj, purchaseOrderId: this.purchaseOrderId, };
      //getting the inventories received
      await this.getByFilterAndReturn(`{purchaseOrderId: ${this.purchaseOrderId}}`).then((res) => {
        this.inventoryList = res;
      });
    } else if (this.serviceOrderId) {
      this.gridId = GRID_ID.SERVICE_ORDER_EXPENSES_GRID;
      this.expensesObj = { ...this.expensesObj, serviceOrderId: this.serviceOrderId };
      if (this.serviceOrderLine && this.serviceOrderLine.serviceOrderId == this.serviceOrderId && this.serviceOrderLine.purchaseOrderLineId) {
        await this.getByFilterAndReturn(`{purchaseOrderLineId: ${this.serviceOrderLine.purchaseOrderLineId}}`).then((res) => {
          this.inventoryList = res;
        });
      }
    }

    this.chargesList();
    this.getExpenseAndIncomeCharges();    
  }

}
</script>